import { getPaymentSession, hasActivePaymentSession } from "@/domain/payment/payment-await-session"
import store from "@/store/store"
import { useCartStore } from "@/store/cart/cart-store"
import { isDevelopmentOnlyLoggingEnabled } from "@/utils/development-only-logging"

const PREFIX = "[PAYMENT_SUCCESS_AUDIT]"

export type PaymentSuccessAuditSnapshot = {
  isLocked: boolean
  isCheckoutLocked: boolean
  processStateWorking: boolean
  hasActivePaymentSession: boolean
  paymentSessionOrderId: string | null
  paymentSessionAttemptId: string | null
  awaitingPaymentOrderId: string | null
  awaitingPaymentAttemptId: string | null
  checkoutUxPhase: string
  cartItemCount: number
}

/** Temporary investigation logging — remove after payment lock regression is resolved. */
export function capturePaymentSuccessAuditSnapshot(): PaymentSuccessAuditSnapshot {
  const cart = useCartStore.getState()
  const state = store.getState()
  const session = getPaymentSession()

  return {
    isLocked: cart.isLocked,
    isCheckoutLocked: cart.isCheckoutLocked,
    processStateWorking: state.processState.working,
    hasActivePaymentSession: hasActivePaymentSession(),
    paymentSessionOrderId: session?.orderId ?? null,
    paymentSessionAttemptId: session?.paymentAttemptId ?? null,
    awaitingPaymentOrderId: state.finalBilling.awaitingPaymentOrderId,
    awaitingPaymentAttemptId: state.finalBilling.awaitingPaymentAttemptId,
    checkoutUxPhase: state.checkoutUx.phase,
    cartItemCount: cart.items.length,
  }
}

export function logPaymentSuccessAudit(
  event: string,
  payload?: Record<string, unknown>
): void {
  if (!isDevelopmentOnlyLoggingEnabled()) return
  // eslint-disable-next-line no-console -- development-only payment success diagnostics
  console.info(PREFIX, event, {
    ts: Date.now(),
    ...capturePaymentSuccessAuditSnapshot(),
    ...payload,
  })
}
